/* eslint-disable no-param-reassign */
import PASubmissionLobDataExtension from './models/PASubmissionLobDataExtension';
import PUPSubmissionLobDataExtension from './models/PUPSubmissionLobDataExtension';

function PolicyLineExtensionConfiguration() {}

PolicyLineExtensionConfiguration.mixinLobBaseDataExtensions = (submission) => {
    if (submission && submission.baseData && submission.baseData.productCode === 'PersonalAuto') {
        submission.lobData = submission.lobData || {};
        if (submission.lobData.personalAuto) {
            submission.lobData.personalAuto.coverables = new PASubmissionLobDataExtension(submission);
        }
    }

    if (submission && submission.baseData && submission.baseData.productCode === 'PersonalUmbrella') {
        submission.lobData = submission.lobData || {};
        submission.lobData.personalUmbrella = new PUPSubmissionLobDataExtension(submission);
    }
};

export default PolicyLineExtensionConfiguration;
